import mitt from "mitt";
const GLOBAL_EVENT_BUS = mitt();

export {GLOBAL_EVENT_BUS};